export default {
  IdNumber: 'رقم الهوية / رقم التليفون',
  password: 'الرقم السري',
  phoneNumber: 'رقم الجوال',
  userName: 'اسم المستخدم',
  fullName: 'الاسم بالكامل',
  email: 'إيميل',
  otbCode: 'الرمز',
  check: 'تحقق',
  enter: 'دخول',
  createNewAccount: ' تسجيل حساب جديد',
  createAccount: ' تسجيل حساب',
  codeOtb: 'كود الرمز',
  otbTitle: 'تم إرسال رسالة إلى رقم الجوال الخاص بكم',
  otbInfo: 'تتضمن رمز OTP',
  continueOtb: 'المتابعة',
  create: 'تسجيل',
  enterLogin: 'تسجيل الدخول'
}
